import React, { Component, Context, CSSProperties } from "react";
import clsx from "clsx";
import LayoutContext, { ILayoutContext } from "../../../contexts/layout/LayoutContext";
import { IImage, VideoMedia } from "../../../models/Image";
import VideoPlayer from "./VideoPlayer";
import ImageView, { ImageProps } from "./ImageView";
import AudioPlayer from "../../audio/AudioPlayer";
import { getIconClass, getFileExtension, UIStyledTooltip } from "../UIComponents";
import { FileType } from "../../../laco-common/base/models/IFile";
import "./MediaView.scss";

type ImageViewComponentProps = ImageProps & { image: IImage; showEmptyImgWhenEmpty?: boolean; index?: number };

// component handles image alignment, centering and caching
// also supports hover effect
class MediaView extends Component<ImageViewComponentProps> {
	private readonly fileType: FileType = this.props.image?.fileType || FileType.IMAGE;
	private readonly onClick = this.props.onClick
		? () => this.props.onClick(this.props.image, this.props.index)
		: undefined;

	state = {
		loading: true,
		image: this.props.image, // update when loaded to adjust view
	};

	renderVideo() {
		// thumbUrl
		console.log("this.state.image:", this.state.image);
		return (
			<div
				className={clsx(this.props.className, "media-view", this.onClick && "media-selectable")}
				onClick={this.onClick}
			>
				<VideoPlayer
					width="100%"
					height="100%"
					video={this.state.image as VideoMedia}
					videoId={this.state.image.docId + this.state.image.filename}
					autoPlay={false}
				></VideoPlayer>
				{this.props.children}
			</div>
		);
	}

	renderFile() {
		let filename: string = this.props.image?.filename || "";
		if (filename.lastIndexOf("?") > 20) {
			filename = filename.substring(0, filename.lastIndexOf("?"));
		}
		const ext: string = getFileExtension(filename);
		const icon = getIconClass(ext);

		return (
			<div
				className={clsx(this.props.className, "media-view file-view", this.onClick && "media-selectable")}
				onClick={this.onClick}
			>
				<i className={icon} />
				<span className="text-xs">{filename}</span>
			</div>
		);
	}

	renderMedia() {
		if (this.props.renderVideo) {
			return this.renderVideo();
		}

		switch (this.fileType) {
			case FileType.AUDIO: {
				return (
					<div
						className={clsx(
							this.props.className,
							"media-view force-mobile-layout",
							this.onClick && "media-selectable"
						)}
						onClick={this.onClick}
					>
						<AudioPlayer
							{...this.props.image}
							omitHeader={true}
							displayEmpty={!this.props.image.url}
							miniPlayer={true}
						>
							{this.props.children}
						</AudioPlayer>
					</div>
				);
			}
			case FileType.VIDEO: {
				return this.renderVideo();
			}
			case FileType.IMAGE: {
				return (
					<ImageView
						{...this.props}
						className={clsx(this.props.className, "media-view", this.onClick && "media-selectable")}
						onClick={this.onClick}
					/>
				);
			}
			default: {
				return this.renderFile();
			}
		}
	}

	render() {
		// const title: string = this.props.image?.filename;
		return this.renderMedia();
	}
}

export default MediaView;
